import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CampaignTable = ({ campaigns, onViewDetails, onMessage, onUpdateStatus }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'completed':
        return 'bg-primary/10 text-primary';
      case 'disputed':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return 'PlayCircle';
      case 'pending':
        return 'Clock';
      case 'completed':
        return 'CheckCircle';
      case 'disputed':
        return 'AlertCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Kampanya</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Influencer</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Bütçe</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">İlerleme</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Son Tarih</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Durum</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {campaigns?.map((campaign) => (
            <tr key={campaign?.id} className="border-b border-border hover:bg-muted/50 transition-smooth">
              <td className="py-4 px-4">
                <div className="flex items-center gap-3">
                  <Image
                    src={campaign?.coverImage}
                    alt={campaign?.coverImageAlt}
                    className="w-12 h-12 rounded-lg object-cover"
                  />
                  <div>
                    <p className="font-medium text-foreground">{campaign?.title}</p>
                    <p className="text-sm text-muted-foreground">{campaign?.type}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center gap-2">
                  <Image
                    src={campaign?.influencerAvatar}
                    alt={campaign?.influencerAvatarAlt}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground">{campaign?.influencerName}</p>
                    <p className="text-xs text-muted-foreground">{campaign?.reach}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <p className="font-semibold text-foreground">{campaign?.budget}</p>
              </td>
              <td className="py-4 px-4">
                <div className="w-32">
                  <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                    <span>{campaign?.progress}%</span>
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-primary transition-all duration-300"
                      style={{ width: `${campaign?.progress}%` }}
                    />
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center gap-1 text-sm text-muted-foreground">
                  <Icon name="Calendar" size={14} />
                  <span>{campaign?.deadline}</span>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(campaign?.status)}`}>
                  <Icon name={getStatusIcon(campaign?.status)} size={14} />
                  <span className="capitalize">{campaign?.status}</span>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center justify-end gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="MessageSquare"
                    onClick={() => onMessage(campaign?.id)}
                  />
                  <Button
                    variant="ghost"
                    size="icon"
                    iconName="Eye"
                    onClick={() => onViewDetails(campaign?.id)}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignTable;